import React from 'react';
import { usePWAIconUpdate } from '../hooks/usePWAIconUpdate';

/**
 * Component that updates PWA icons based on current route
 * Should be placed at the app root level
 */
const PWAIconUpdater: React.FC = () => {
  usePWAIconUpdate();
  return null; // This component doesn't render anything
};

export default PWAIconUpdater;

